import { parsePhoneNumber } from 'awesome-phonenumber'

import { REGION_CODE_DEFAULT } from './constants'

export function getParsedPhoneNumber(telephoneNumber: string): string {
  if (!telephoneNumber) {
    return ''
  }

  return parsePhoneNumber(telephoneNumber, REGION_CODE_DEFAULT).getNumberFrom(REGION_CODE_DEFAULT)
}

export function getTelephoneNumberWithCode(telephoneNumber: string): string {
  if (includesAreaCode(telephoneNumber)) {
    return telephoneNumber
  }

  return `+420${telephoneNumber}`
}

function includesAreaCode(phoneNumber: string): boolean {
  const codeVariants = ['+', '00']

  return codeVariants.some(code => phoneNumber.startsWith(code))
}
